export default "__VITE_ASSET__D916CqWv__"